import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { SupportService } from '../support.service';

@Component({
    selector: 'dialog-preview',
    templateUrl: 'dialog-preview.component.html',
    styleUrls: ['dialog-preview.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [SupportService]
})
export class DialogPreviewComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public supportService : SupportService) {}

    viewed = false;

    countView(data) {
        if (!this.viewed) {
            this.viewed = true;
            this.supportService.countView({ id : data.id}).subscribe();
        }
    }
}
